import { Controller } from "@hotwired/stimulus"

// Preserves scroll position across Turbo Stream updates
// Usage: data-controller="preserve-scroll" on a scrollable container
export default class extends Controller {
  connect() {
    this.scrollTop = 0

    // Save scroll position before Turbo updates
    document.addEventListener("turbo:before-stream-render", this.saveScroll)

    // Restore after render
    document.addEventListener("turbo:render", this.restoreScroll)
  }

  disconnect() {
    document.removeEventListener("turbo:before-stream-render", this.saveScroll)
    document.removeEventListener("turbo:render", this.restoreScroll)
  }

  saveScroll = () => {
    this.scrollTop = this.element.scrollTop
  }

  restoreScroll = () => {
    if (this.scrollTop > 0) {
      // Use requestAnimationFrame to ensure DOM is updated
      requestAnimationFrame(() => {
        this.element.scrollTop = this.scrollTop
      })
    }
  }
}
